import { URLType } from './url.config';

export function users(prefix: string): URLType {
  return {
    HOME: `${prefix}/home`,
  };
}
